import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";

import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { GlobalState } from "context/GlobalContext";

import axios from "axios";

import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import ClearRounded from "@mui/icons-material/ClearRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import FactoryInfoModal from "./FactoryInfoModal/FactoryInfoModal";
import moment from "moment";
import EditFactoryDetails from "../FactoryDetails/EditFactoryDetails/EditFactoryDetails";
import {
	EditCompanyDetailsModalTypes,
	factoryUrlParamName,
	foreignKeys,
	supplierDrawerElements,
	supplierUrlParamName,
} from "data/supplierPageData";
import { useNavigate, useSearchParams } from "react-router-dom";

const factoryTablecolumns = [
	{
		field: "name",
		headerName: "Name",
		align: "center",
		headerAlign: "center",
		width: 180,
	},
	{
		field: "factory_liscence_no",
		headerName: "Factory Liscence No",
		align: "center",
		headerAlign: "center",
		width: 180,
	},
	{
		field: "factory_liscence_expiry_date",
		headerName: "Liscence Expiry Date",
		align: "center",
		headerAlign: "center",
		width: 180,
		renderCell: ({ row }) => {
			return <div>{moment(row.factory_liscence_expiry_date).format("DD-MM-YYYY")}</div>;
		},
	},
	{ field: "factory_city", headerAlign: "center", align: "center", headerName: "City", width: 140 },
	{ field: "factory_state", headerAlign: "center", align: "center", headerName: "State", width: 130 },
	{
		field: "factory_gst_no",
		headerAlign: "center",
		align: "center",
		headerName: "GST No",
		width: 130,
	},
	{
		field: "factory_pincode",
		headerAlign: "center",
		align: "center",
		headerName: "Factory Pincode",
		width: 130,
	},
];

const AllFactories = ({ factories, setFactories, selectedFactory, setSelectedFactory, companyData, setTab, disableEdit }) => {
	// def value is true becoz for textfield disabled =true;
	const [modalOpen, setModalOpen] = useState(false);
	const [searchParams, setSearchParams] = useSearchParams();

	const { setSnackBar, snackBar, setSnackBarOpen, setLoadingOpen } = GlobalState();

	const handleGridRowClick = async (data) => {
		try {
			const factory = await axios.get(`/api/supplier/factory?id=${data.id}`);
			setSelectedFactory({ ...factory.data.result });
			setSearchParams((params) => {
				params.set(supplierUrlParamName, supplierDrawerElements.factory.key);
				params.set(factoryUrlParamName, data.id);
				return params;
			});
			setTab(supplierDrawerElements.factory.key);
		} catch (error) {
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Unable To Get factory details",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};
	const createFactory = async (body, setModalOpen) => {
		const obj = {};
		obj[foreignKeys.supplier] = companyData.id;
		setLoadingOpen(true);

		try {
			let res = await axios.post(`/api/supplier/create_factory`, { ...body, ...obj });
			setSelectedFactory({ ...selectedFactory, ...body });
			setFactories([...factories, res.data.result]);
			setSearchParams((prev) => {
				const newParams = new URLSearchParams(prev);
				newParams.set(supplierUrlParamName, supplierDrawerElements.factory.key);
				newParams.set("id", res.data.result.id);
				return newParams;
			});
			setLoadingOpen(false);
			setModalOpen(false);
			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Crated",
				severity: "success",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		} catch (error) {
			setLoadingOpen(false);

			setSnackBarOpen(true);
			setSnackBar({
				...snackBar,
				message: "Unable To Update Details",
				severity: "error",
				anchorOrigin: { horizontal: "center", vertical: "top" },
			});
		}
	};
	return (
		<Stack maxWidth="1100px" spacing={3} margin="auto">
			<Box display="flex" alignItems="center" pt={4} justifyContent="space-between">
				<Typography variant="h4">All Factories</Typography>
				<Box sx={{ display: disableEdit ? "none" : "block" }}>
					<Button
						variant="contained"
						size="small"
						fullwidth
						startIcon={<AddRoundedIcon />}
						onClick={() => setModalOpen(true)}>
						New Factory
					</Button>
				</Box>
			</Box>
			{/* table */}
			<Stack width="100%">
				<DataGrid
					key={factories}
					rows={factories}
					columns={factoryTablecolumns}
					sx={{
						minHeight: 430,
						"& .MuiDataGrid-row": {
							cursor: "pointer",
						},
						"& .MuiDataGrid-cell": {
							padding: "10px",
						},
					}}
					showColumnVerticalBorder
					onRowClick={(params) => {
						handleGridRowClick(params.row);
					}}
					initialState={{
						pagination: {
							paginationModel: { pageSize: 10 },
						},
					}}
					autoHeight
					disableRowSelectionOnClick
					pageSizeOptions={[5, 10]}
				/>
			</Stack>

			<EditFactoryDetails
				modalOpen={modalOpen}
				setModalOpen={setModalOpen}
				basicDetails={selectedFactory}
				setBasicDetails={setSelectedFactory}
				type={EditCompanyDetailsModalTypes.onbarding}
				submitFunction={createFactory}
			/>
		</Stack>
	);
};

export default AllFactories;
